type WarehouseStockBuckets = {
  warehouseId: string;
  blockedStock: number;
  stockDiscrepancy?: number;
  stockDiscrepancyProducts?: number;
  lostStock?: number;
  surplusStock?: number;
  lostProducts?: number;
  surplusProducts?: number;
};

export const lostStockOf = (stock: WarehouseStockBuckets) =>
  stock.lostStock ?? Math.max(0, stock.stockDiscrepancy ?? 0);

export const surplusStockOf = (stock: WarehouseStockBuckets) =>
  stock.surplusStock ?? Math.max(0, -(stock.stockDiscrepancy ?? 0));

export const lostProductsOf = (stock: WarehouseStockBuckets) =>
  stock.lostProducts ?? Math.max(0, stock.stockDiscrepancyProducts ?? 0);

export const surplusProductsOf = (stock: WarehouseStockBuckets) =>
  stock.surplusProducts ?? Math.max(0, -(stock.stockDiscrepancyProducts ?? 0));

const bucketForWarehouse = (
  stockByWarehouse: WarehouseStockBuckets[],
  warehouseId: string | null | undefined,
  bucketOf: (stock: WarehouseStockBuckets) => number
) => {
  if (warehouseId === 'All') {
    return stockByWarehouse.reduce((total, stock) => total + bucketOf(stock), 0);
  }

  const warehouseStock = stockByWarehouse.find(
    (stock) => stock.warehouseId === warehouseId
  );

  return warehouseStock ? bucketOf(warehouseStock) : 0;
};

export const displayedBlockedStock = (
  stockByWarehouse: WarehouseStockBuckets[],
  warehouseId?: string | null
) =>
  bucketForWarehouse(stockByWarehouse, warehouseId, (stock) => stock.blockedStock);

export const displayedLostStock = (
  stockByWarehouse: WarehouseStockBuckets[],
  warehouseId?: string | null
) => bucketForWarehouse(stockByWarehouse, warehouseId, lostStockOf);

export const displayedSurplusStock = (
  stockByWarehouse: WarehouseStockBuckets[],
  warehouseId?: string | null
) => bucketForWarehouse(stockByWarehouse, warehouseId, surplusStockOf);

export const displayedLostProducts = (
  stockByWarehouse: WarehouseStockBuckets[],
  warehouseId?: string | null
) => bucketForWarehouse(stockByWarehouse, warehouseId, lostProductsOf);

export const displayedSurplusProducts = (
  stockByWarehouse: WarehouseStockBuckets[],
  warehouseId?: string | null
) => bucketForWarehouse(stockByWarehouse, warehouseId, surplusProductsOf);
